import React from 'react'
import Pt from 'prop-types'
import Ipt from 'react-immutable-proptypes'
import { Col, FormControl, HelpBlock, Row } from 'react-bootstrap'

import { DateOfBirthField } from 'internal-components/src/components/Form'
import FormField from 'internal-components/src/components/Form/FormField'
import Password from 'internal-components/src/components/Form/Password'

import RegisteredEmailField from '../Form/RegisteredEmailField'

export default function AccountDetails({
  authenticate,
  emailChecking,
  emailRegistered,
  errors,
  privateDetails = true,
  renderRegistered,
  setChallengePhrase,
  setContact,
  setDateOfBirth,
  setEmail,
  setEmailConfirm,
  setFirstName,
  setLastName,
  setUserPassword,
  signup,
}) {
  const your = privateDetails ? 'Your ' : ''

  return (
    <div className="account-creator">
      <Row>
        <Col sm={6}>
          <FormField
            bsSize="large"
            controlId="firstName"
            controlLabel={`${your}First Name`}
            errors={errors}
            onChange={e => setFirstName(e.target.value)}
            required
            value={signup.get('firstName') || ''}
          />
        </Col>
        <Col sm={6}>
          <FormField
            bsSize="large"
            controlId="lastName"
            controlLabel={`${your}Last Name`}
            errors={errors}
            onChange={e => setLastName(e.target.value)}
            required
            value={signup.get('lastName') || ''}
          />
        </Col>
      </Row>

      <Row>
        <Col sm={6}>
          <RegisteredEmailField
            authenticate={authenticate}
            bsSize="large"
            controlId="email"
            controlLabel={`${your}Email Address`}
            emailChecking={emailChecking}
            emailRegistered={emailRegistered}
            errors={errors}
            onChange={e => setEmail(e.target.value)}
            renderRegistered={renderRegistered}
            required
            value={signup.get('email') || ''}
          />
        </Col>

        <Col sm={6}>
          <FormField
            bsSize="large"
            controlId="emailConfirm"
            controlLabel={`Confirm ${your}Email Address`}
            errors={errors}
            onChange={e => setEmailConfirm(e.target.value)}
            placeholder={`Confirm ${your}Email Address`}
            required
            value={signup.get('emailConfirm') || ''}
          />
        </Col>
      </Row>

      <FormField
        bsSize="large"
        controlId="contact"
        controlLabel="Primary Contact Number"
        errors={errors}
        onChange={e => setContact(e.target.value)}
        required
        value={signup.get('contact') || ''}
      />

      {privateDetails && (
        <FormField
          bsSize="large"
          controlLabel="Your Date of Birth"
          data-controlId="dateOfBirth"
          errorKey="dateOfBirth"
          errors={errors}
          required
          value={signup.get('dateOfBirth')}
        >
          <DateOfBirthField
            required
            setDateOfBirth={setDateOfBirth}
            value={signup.get('dateOfBirth')}
          />
        </FormField>
      )}
    </div>
  )
}

AccountDetails.propTypes = {
  authenticate: Pt.oneOfType([Pt.func, Pt.bool]).isRequired,
  emailChecking: Pt.bool,
  emailRegistered: Pt.bool,
  errors: Ipt.map.isRequired,
  privateDetails: Pt.bool,
  renderRegistered: Pt.func,
  setChallengePhrase: Pt.func.isRequired,
  setContact: Pt.func.isRequired,
  setDateOfBirth: Pt.func.isRequired,
  setEmail: Pt.func.isRequired,
  setEmailConfirm: Pt.func.isRequired,
  setFirstName: Pt.func.isRequired,
  setLastName: Pt.func.isRequired,
  setUserPassword: Pt.func.isRequired,
  signup: Ipt.record.isRequired,
}



// WEBPACK FOOTER //
// ./src/components/Signup/AccountDetails.jsx